import React, { memo } from "react";
import { ADMIN_LANG } from "../../../settings";
import { SelectData } from "../../../types/admin";
import {Col, Table} from "react-bootstrap";

// Memoized row component
const SelectTableRow = memo(({ option }: { option: SelectData }) => {
    const pointColor = option.points > 0 ? 'text-success' : (option.points < 0 ? 'text-danger' : 'text-muted');

    return (
        <tr>
            <td>{option.name}</td>
            <td className={`text-center ${pointColor}`}>{option.points}</td>
            <td className="text-center">{option.selections} {ADMIN_LANG.times}</td>
        </tr>
    );
});

const SelectTable = ({ optionsData }: { optionsData: SelectData[] }) => {
    return (
        <Col xs={12} md={6}>
        <div className="admin-card">
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th>{ADMIN_LANG.name}</th>
                        <th className="text-center">{ADMIN_LANG.points}</th>
                        <th className="text-center">{ADMIN_LANG.selections}</th>
                    </tr>
                </thead>
                <tbody>
                    {optionsData.map((option, index) => (
                        <SelectTableRow key={index} option={option} />
                    ))}
                </tbody>
            </Table>
        </div>
        </Col>
    );
};

export default memo(SelectTable);